import { makeStyles } from '@mui/styles';
import LoginRightBg from '../../assets/svg/login-right-bg.svg';
import LoginLeftBg from '../../assets/svg/login-left-bg.svg';

export const useStyles = makeStyles((theme) => {
    return {
        root: {
            display: "flex",
            height: "100vh",
            width: "100%",
        },
        leftView: {
            backgroundImage: `url(${LoginLeftBg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            color: theme.palette.common.white,
            padding: theme.spacing(10),
            position: 'relative',
            width: '50%',
        },
        textView: {
            width: "45%",
            "& p": {
                color: theme.palette.grey[300],
                opacity: 0.8
            }
        },
        banner: {
            position: "absolute",
            bottom: 0,
            right: 0
        },
        rightView: {
            width: '50%',
            display: 'flex',
            height: "100vh",
            flexDirection: "column",
            alignItems: "center",
            backgroundImage: `url(${LoginRightBg})`,
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
        },
        logo: {
            position: "absolute",
            top: theme.spacing(3),
            right: theme.spacing(3),
        },
        body: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            justifyContent: "center",
            height: "100%",
            gridGap: theme.spacing(1)
        },
        warningView: {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            background: theme.palette.background.error,
            color: theme.palette.error.main,
            borderRadius: theme.spacing(1),
            padding: theme.spacing(1, 3),
        },
        loginBtn: {
            color: theme.palette.common.white,
            borderRadius: "32px !important",
            padding: "8px 80px !important",
            marginTop: "30px !important",
            backgroundColor: theme.palette.blue[1]
        },
        slideContainer: {
            display: "flex",
            flexDirection: "column",
        },
        textCarousel: {
            textAlign: "center",
            padding: "0 10%",
            fontSize: "16px",
            "& h2": {
                fontSize: "18px",
                fontWeight: 600
            }
        },
        loginSlickDots: {
            width: "100%",
            listStyle: "none",
            textAlign: "center",
            padding: "0px",
            "& li": {
                position: "relative",
                display: "inline-block",
                width: "20px",
                height: "20px",
                padding: "0",
                cursor: "pointer",
                "& button": {
                    fontSize: "0",
                    lineHeight: "0",
                    display: "block",
                    width: "20px",
                    height: "20px",
                    padding: "5px",
                    cursor: "pointer",
                    color: "transparent",
                    border: "0",
                    outline: "0",
                    background: "0 0",
                    "&:before": {
                        fontSize: "30px",
                        lineHeight: "20px",
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "20px",
                        height: "20px",
                        content: '"•"',
                        textAlign: "center",
                        opacity: 0.8,
                        color: "#DADADA",
                    },
                    "&:focus, &:hover": {
                        outline: "0",
                        "&:before": {
                            opacity: 1
                        }
                    }
                }
            },
            "& .slick-active": {
                "& button": {
                    "&:before": {
                        fontSize: "30px",
                        opacity: 0.9,
                        color: "#E88363"
                    }
                }
            }
        },
    };
});
